import { useMemo } from 'react';
import classnames from 'classnames/bind';
import { InsightsIcon } from 'tuui';
import { TOOLTIP_POSITION, TooltipV2 as Tooltip } from 'taboola-ultimate-ui';
import { InternalLink } from 'components';
import { useSimulatorMonitor, SIMULATOR_MONITOR_ID } from 'components/SimulatorButton/hooks/useSimulatorMonitor';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { CAMPAIGN_STATUS } from '../../../../../config';
import { generateCampaignSimulatorPreviewPath } from '../../../../../services/utils';
import ActionableTextCellRenderer from '../ActionableTextCellRenderer';
import InternalLinkCellRenderer from '../InternalLinkCellRenderer';
import { useSimulatorPermission } from './useSimulatorPermission';
import styles from './campaignNameCellRenderer.module.scss';

const classNameBuilder = classnames.bind(styles);

export const CampaignNameCellRenderer = props => {
    const {
        data: { isPerformanceSimulatorAvailable, status, id, accountName, bidStrategy },
    } = props;

    const isSimulatorPermitted = useSimulatorPermission({ bidStrategy });
    const isSimulatorEnabled = isPerformanceSimulatorAvailable && status === CAMPAIGN_STATUS.RUNNING;
    const { trackSimulatorClick } = useSimulatorMonitor(SIMULATOR_MONITOR_ID.CAMPAIGN_NAME_CELL);

    const simulatorPath = useMemo(
        () =>
            accountName && id
                ? generateCampaignSimulatorPreviewPath({
                      campaignId: id,
                      accountId: accountName,
                  })
                : null,
        [accountName, id]
    );

    return (
        <ActionableTextCellRenderer {...props}>
            <div className={styles['container']}>
                <div className={styles['campaign-link']}>
                    <InternalLinkCellRenderer {...props} />
                </div>
                {isSimulatorPermitted && (
                    <div>
                        <InternalLink path={simulatorPath} disabled={!isSimulatorEnabled} onClick={trackSimulatorClick}>
                            <InsightsIcon
                                className={classNameBuilder('icon', { disabled: !isSimulatorEnabled })}
                                fontSize="small"
                            />
                        </InternalLink>
                        <Tooltip position={TOOLTIP_POSITION.TOP} arrow>
                            <FormattedMessage
                                id={
                                    isSimulatorEnabled
                                        ? 'app.campaigns.reports.grid.column.header.tooltip.campaign.simulator'
                                        : 'app.campaigns.reports.grid.column.header.tooltip.campaign.simulator.disabled'
                                }
                            />
                        </Tooltip>
                    </div>
                )}
            </div>
        </ActionableTextCellRenderer>
    );
};
